import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { LocalSettingsDTO, UpdateLocalSettingsDTO } from "../models/localSettings/localSettings.request";



export const localSettingsService = {

    async getLocalSettings(localId: string): Promise<ApiResponse<LocalSettingsDTO>> {
        const { data } = await api.get<ApiResponse<LocalSettingsDTO>>(`/locals/${localId}/settings/default`);
        return data;
    },

    async updateLocalSettings(localId: string, settings: UpdateLocalSettingsDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/settings/default`, settings);
        return data;
    }
}